module.exports = __webpack_public_path__ + "static/media/abhinav kurule.3b86cc4d.jpeg";